/* ==========================================================================
   LAUZON — hero countdown (2026-09-09)

   Drives .lzp-countdown, rendered by sections/lauzon-page-hero.liquid when a
   Countdown target is set. Built for /pages/beyond-the-burst, whose drop opens
   2026-09-13T19:00:00Z (3:00 PM Eastern — September is daylight time, so the
   offset is -04:00, not -05:00).

   ── THREE THINGS THAT ARE DELIBERATE ──────────────────────────────────────

   🔴 NO document.hidden GUARD. A tick loop that parks while the document
   reports itself hidden looks dead exactly when someone is watching it: the
   Browser pane reads document.hidden true even on a fronted tab, and a
   backgrounded real tab returns to a frozen clock instead of a caught-up one.
   setInterval is throttled in a background tab anyway, and every tick recomputes
   from Date.now() rather than decrementing, so a throttled or slept tab paints
   the right number on its first tick back. Guarding buys nothing and costs the
   only thing this element does.

   🔴 THE NUMBERS ARE NOT SERVER-RENDERED. Liquid renders at the CDN, not on
   the visitor's clock, so any number it printed would be wrong by the age of
   the cached page — and wrong in the most visible way, a stale figure that sits
   there until the first tick corrects it. The markup ships "--" and the first
   tick runs immediately, before the interval is armed, so the placeholders are
   replaced in the same frame the script executes.

   🔴 THE GRID IS aria-hidden. A four-cell readout that changes every second is
   an aria-live tarpit — a screen reader would announce the seconds forever. The
   live region is the label, and it carries a plain-language equivalent
   ("3 days, 21 hours") refreshed only when the minute changes.

   Styles: assets/lauzon-pages.css (.lzp-countdown-*).
   ========================================================================== */

(function () {
  'use strict';

  function pad(n) {
    /* Two digits minimum, no maximum: a target 120 days out reads "120", not
       a capped "99". */
    return n < 10 ? '0' + n : String(n);
  }

  function unit(n, word) {
    return n + ' ' + word + (n === 1 ? '' : 's');
  }

  /* Two units is what a person says out loud. Below a day the hour leads,
     below an hour the minutes stand alone — seconds never reach this string. */
  function phrase(d, h, m) {
    if (d > 0) return unit(d, 'day') + ', ' + unit(h, 'hour');
    if (h > 0) return unit(h, 'hour') + ', ' + unit(m, 'minute');
    return unit(m, 'minute');
  }

  function init(root) {
    if (root.getAttribute('data-countdown-init') === 'true') return;
    root.setAttribute('data-countdown-init', 'true');

    var target = Date.parse(root.getAttribute('data-countdown') || '');
    var grid = root.querySelector('[data-cd-grid]');
    var labelEl = root.querySelector('[data-cd-label]');
    var srEl = root.querySelector('[data-cd-sr]');

    /* An unparseable target is a typo in the theme editor, not a state worth
       showing a customer: hide rather than leave "--" on the page. */
    if (isNaN(target) || !grid) {
      root.hidden = true;
      return;
    }

    var cells = {
      d: grid.querySelector('[data-cd="d"]'),
      h: grid.querySelector('[data-cd="h"]'),
      m: grid.querySelector('[data-cd="m"]'),
      s: grid.querySelector('[data-cd="s"]')
    };

    var timer = null;
    var opened = false;
    var lastPhrase = '';

    function open() {
      if (opened) return;
      opened = true;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }

      var link = root.getAttribute('data-open-link');
      var cta = root.getAttribute('data-open-cta');
      var openLabel = root.getAttribute('data-open-label');

      if (labelEl && openLabel) labelEl.textContent = openLabel;
      if (srEl) srEl.textContent = '';

      if (link && cta) {
        var a = document.createElement('a');
        a.className = 'pill-link lzp-countdown-open';
        a.setAttribute('href', link);
        a.textContent = cta;
        grid.parentNode.replaceChild(a, grid);
      } else if (grid.parentNode) {
        grid.parentNode.removeChild(grid);
      }

      root.setAttribute('data-cd-state', 'open');
    }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        open();
        return;
      }

      var total = Math.floor(diff / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      if (cells.d) cells.d.textContent = pad(d);
      if (cells.h) cells.h.textContent = pad(h);
      if (cells.m) cells.m.textContent = pad(m);
      if (cells.s) cells.s.textContent = pad(s);

      /* The live region only ever changes on a minute boundary. */
      var said = phrase(d, h, m);
      if (said !== lastPhrase) {
        lastPhrase = said;
        if (srEl) srEl.textContent = said;
      }
    }

    /* Immediately, then on the second — so the placeholders never show. */
    tick();
    if (!opened) timer = setInterval(tick, 1000);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-countdown]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  /* Loaded with defer, so the document is parsed by the time this runs. */
  initAll(document);

  /* Re-run for a section the theme editor re-renders in place. */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
